import React, { PureComponent } from 'react';
import s from './Content.scss';
import { Button, Heading } from 'wix-style-react';
import { errorMapping } from './errorsMaping';
import { WithTranslation } from 'react-i18next';
import { errorDataType } from '../../errorData';

interface ContentProps extends WithTranslation {
  errorData: errorDataType;
}

export class Content extends PureComponent<ContentProps> {
  render() {
    const { t, errorData } = this.props;
    const { errorCode } = errorData;
    const errorTemplate = errorMapping[errorCode] || errorMapping.default;

    return (
      <div className={s.pageContent}>
        {errorTemplate.title && (
          <Heading className={s.title} appearance="H1" light>
            <span
              className={s.text}
              dangerouslySetInnerHTML={{ __html: t(errorTemplate.title) }}
            />
            {errorTemplate.code && (
              <>
                <br />
                <span className={s.errorCode}>
                  {t('editorx.error-code', { errorCode: errorTemplate.code })}
                </span>
              </>
            )}
          </Heading>
        )}

        {errorTemplate.subtitle && (
          <Heading className={s.subTitle} appearance="H2" light>
            {t(errorTemplate.subtitle)}
          </Heading>
        )}

        {errorTemplate.content && (
          <div className={s.content}>{errorTemplate.content(t)}</div>
        )}

        {errorTemplate.buttonLink && errorTemplate.button && (
          <div className={s.actions}>
            <Button
              skin="inverted"
              size="large"
              className={s.actionButton}
              onClick={() =>
                (window.location.href = errorTemplate.buttonLink || '')
              }
            >
              {t(errorTemplate.button)}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
